import axios from "axios"

const newHttpClient = function () {
  const instance = axios.create()

  instance.interceptors.request.use((config) => {
    if (!config.headers) {
      config.headers = {}
    }

    config.headers["Content-Type"] = "application/json"

    return config
  })

  instance.interceptors.response.use(
    (response) => {
      return response
    },
    (error) => {
      return Promise.reject(error)
    }
  )

  return instance
}

export default newHttpClient()
